import { Box, Button, DialogActions, DialogContent, DialogTitle, Grid, SelectChangeEvent, Typography, CardContent, TextField, Divider, Checkbox, CircularProgress, Dialog, DialogContentText, Alert, Snackbar } from '@mui/material';
import React, { FC, useEffect, useState, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector, } from "../../store/hooks";
import CustomTextField from '../FormFields/CustomTextField';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import LoadingButton from '@mui/lab/LoadingButton';
import moment from 'moment';
import { Utils, VocuherTypes } from "../../utils/common-utils";
import Radio from "@mui/material/Radio";

import {
  GridValueGetterParams,
  GridColDef,
  GridActionsCellItem,
  GridSelectionModel,
} from "@mui/x-data-grid";

import CustomDataGrid from '../../components/DataGrid/DataGrid';

//Dropdown imports
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import { ApiStatus } from "../../utils/api.types";
import { fetchInvoices, manualPayment } from '../../store/invoiceStore/invoiceThunk';
import CustomSelect, { IOptions } from '../FormFields/CustomSelect';
import { PaymentReceipt, PaymentReceiptApplication, SettleInvoicePayment } from '../../utils/invoice.types';
import { attachInvoiceToPayment } from '../../store/CashInflowStore/cashInflowThunk';
import { attachInvoiceToVendorPayment } from '../../store/CashOutflowStore/cashOutflowThunk';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { da } from 'date-fns/locale';
import { AInvoice } from '../../utils/invoice.types';
import { fetchTaxRates } from '../../store/gstStore/gstThunk';
import { Shrink } from 'lucide-react';
import { toast } from 'react-toastify';

interface DialogInvoiceToPaymentFormProps {
  title: String;
  open: Boolean;
  data?: any;
  selectedBuyerOrSupplierId: any;
  isInflow?: boolean;
  onClose: (refresh: boolean) => void;
}

const DialogInvoiceToPaymentForm: FC<DialogInvoiceToPaymentFormProps> = ({ onClose, open, title, data, selectedBuyerOrSupplierId, isInflow }) => {

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { status: inflowStatus } = useAppSelector(state => state.cashInflow);
  const { status: outflowStatus } = useAppSelector(state => state.cashOutflow);
  const status = isInflow ? inflowStatus : outflowStatus;
  const { invoices } = useAppSelector(state => state?.invoices);
  const { selectedAccount } = useAppSelector(state => state.auth);

  const [startDate, setStartDate] = useState<Date>(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000));
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [showError, setShowError] = useState<Boolean>(false);
  const [showErrorMessage, setShowErrorMessage] = useState<String>('');
  const [showErrorDesc, setShowErrorDesc] = useState<String>('');

  // Enhanced error handling states
  const [excessPaymentDialog, setExcessPaymentDialog] = useState({
    open: false,
    amount: 0,
    mode: ''
  });
  const [successSnackbar, setSuccessSnackbar] = useState({
    open: false,
    message: ''
  });
  const [warningSnackbar, setWarningSnackbar] = useState({
    open: false,
    message: ''
  });
  const [errorSnackbar, setErrorSnackbar] = useState({
    open: false,
    message: ''
  });

  const [selectedAmountRange, setSelectedAmountRange] = useState('0 - 99999');
  const [selectedInvoiceStatus, setSelectedInvoiceStatus] = useState('PENDING');
  let radioChecked: string[] = [];
  const [selectedInvoice, setSelectedInvoice] = useState(radioChecked);
  
  const [fetchedInvoices, setFetchedInvoices] = useState<AInvoice[]>([]);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [selectedInvoicesUpdated, setSelectedInvoicesUpdated] = useState<AInvoice[]>([]);
  
  const [amountRecevied, setAmountRecevied] = useState<Number>(0);
  const [totalPaymentReceiptAmount, setTotalPaymentReceiptAmount] = useState<Number>(data.total_unapplied);
  const [totalUnappliedAmount, setTotalUnappliedAmount] = useState<Number>(data.total_unapplied);
  const [totalAppliedAmount, setTotalAappliedAmount] = useState<Number>(0);

  const [taxRateOptions, setTaxRateOptions] = useState<any>();
  const [tdsTaxRateOptions, setTdsTaxRateOptions] = useState<any[]>([]);
  const [tcsTaxRateOptions, setTcsTaxRateOptions] = useState<IOptions[]>([]);

  const [tdsSelected, setTdsSelected] = useState({
    _id: "",
    label: "",
    rate: 0
  })

  const [invoiceStatusOptions, setInvoiceStatusOptions] = useState<IOptions[]>([
    { label: 'Paid', value: 'PAID' },
    { label: 'Partially Paid', value: 'PARTIALLY_PAID' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Invoice Sent', value: 'INVOICE_SENT' }

  ]);

  const [amountRangeOptions, setAmountRangeOptions] = useState<IOptions[]>([
    { label: 'Below 1 Lakh', value: '0 - 99999' },
    { label: '1,00,000 - 3,00,000', value: '100000 - 300000' },
    { label: '3,00,001 - 5,00,000', value: '300001 - 500000' },
    { label: '5,00,001 - 7,00,000', value: '500001 - 700000' },
    { label: '7,00,001 - 9,00,000', value: '700001 - 900000' },
    { label: '9,00,001 & Above', value: '900001 & Above' }
  ]);

  const handleDateChange = (newValue: Date | null, name: string | undefined) => {
    if (newValue) {
      if (name === 'startDate')
        setStartDate(newValue);
      else if (name === 'endDate')
        setEndDate(newValue);
    }
  };

  // Schema to validate payment form.
  const schema = yup.object().shape({
    // amountRecevied: yup.string().required("Enter payment Amount"),
    // base: yup.string().required("Base Amount is required."),
    // tax: yup.string().required("Tax is required."),
    // tds: yup.string().required("TDS is required."),
  });

  const methods = useForm<any>({ mode: 'onChange', reValidateMode: 'onChange', resolver: yupResolver(schema) });

  useEffect(() => {
      let isMounted = true;
      const getTdsTcsTaxRates = async () => {
        dispatch(fetchTaxRates()).unwrap().then(async (data) => {
          if (data) {
            if (data.length > 0) {
              setTaxRateOptions(data)
              let tdsRates = data.filter((items) => items.taxType == "tds");
              let tcsRates = data.filter((items) => items.taxType == "tcs");
  
              await tdsRates.forEach(async (item: string | any) => {
                setTdsTaxRateOptions((taxOptions: any) => ([...taxOptions, {
                  label: `${item.taxRate}% - ${item.taxSection} ${item.taxName}`,
                  value: item._id
                }]));
              });
  
              await tcsRates.forEach(async (item: string | any) => {
                setTcsTaxRateOptions((taxOptions: any) => ([...taxOptions, {
                  label: `${item.taxRate}% - ${item.taxSection} ${item.taxName}`,
                  value: item._id
                }]));
              });
            }
          }
        });
      }
      if(isMounted) {
        getTdsTcsTaxRates()
      }
      return () => {
        isMounted = false;
      };
  
    }, []);

  useEffect(() => {
    getInvoices();
    // updateInvoiceData() 
  }, [selectedInvoiceStatus, startDate, endDate, selectedAmountRange]);

  // Memoize selectionModel to ensure stable reference
  const memoizedSelectionModel = useMemo(() => {
    return selectedRows || [];
  }, [selectedRows]);

  useEffect(() => {
    if(invoices.length > 0 ) {
      let totalOutstanding =  Number(0);
      // Make a shallow copy before sorting to avoid mutating a read-only array
      const sortedInvoices = [...invoices].sort(
        (a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime()
      );
      sortedInvoices.map((a: any) => {
        totalOutstanding += Number(a.balanceAmount);
        return a;
      });
      console.log("Calculated total outstanding after initial outstanding to be received  ===>" + totalOutstanding);

      let data12 = sortedInvoices.map((row: any) => {
        return { 
          ...row, 
          paymentAmount: 0, 
          tempBalanceAmount: row.balanceAmount,
          isManuallyEdited: false,
          originalPaymentAmount: 0
        };
      });
      setFetchedInvoices(data12);
    } else {
      setFetchedInvoices([])
    }
    
  }, [invoices]);

  useEffect(() => {
        console.log("useffect called ---")
        if (fetchedInvoices.length > 0 ) {
          console.log("useffect called inside if  ---")
          let totalSum = Number(0);
          const defaultSelected = fetchedInvoices
            .filter((invoice) => Number(invoice.paymentAmount) > 0)
            .map((invoiceN) => { 
              totalSum += Number(invoiceN.paymentAmount);
              console.log("some value")
              console.log("invoiceN.tdsSelected", invoiceN.tdsSelected)
              return {
                _id: invoiceN._id,
                invoiceNumber: invoiceN.invoiceNumber,
                paymentAmount: invoiceN.paymentAmount, 
                pdfTemplate: invoiceN.pdfTemplate, 
                principalAmount: invoiceN.principalAmount, 
                finalTax: invoiceN.finalTax, 
                tdsSelected: invoiceN.tdsSelected
              }
            });
          
          console.log("totalSum ==> ", totalSum)
          console.log("defaultSelected ==> ", defaultSelected)
          setTotalAappliedAmount(totalSum)
          // Fix: Set selectedRows to IDs only for DataGrid selectionModel
          setSelectedRows(defaultSelected.map(item => item._id));
          // Set the objects separately for business logic (cast to AInvoice[] to handle partial objects)
          setSelectedInvoicesUpdated(defaultSelected as AInvoice[]);
        }
      }, [fetchedInvoices]); // Runs whenever invoices change

  // useEffect(() => {
  //   console.log('useeffect called cehckis 1111  ', fetchedInvoices.length)
  //   if (fetchedInvoices.length > 0 ) {
  //     console.log('calling in newpaymentamount start === ')
  //     applyNewPyamentAmount(totalPaymentReceiptAmount)
  //     console.log('calling in newpaymentamount end ====')
  //   }
  // }, [])

  const getInvoices = async () => {
    const { _id: id } = selectedAccount;
    let params = ""
    if (selectedBuyerOrSupplierId) {
      params += "filter=" + selectedBuyerOrSupplierId;
    }

    if (startDate) {
      params += "&startDate=" + new Date(startDate).getTime();
    }

    if (endDate) {
      params += "&endDate=" + new Date(endDate).getTime();
    }

    if (selectedInvoiceStatus) {
      params += "&status=PENDING,PARTIALLY_PAID";
    }
    if (selectedAmountRange) {
      let tArray = selectedAmountRange.split("-");
      if (tArray.length == 2) {
        let start = tArray[0];
        let end = tArray[1];
        params += "&amountStartRange=" + start + "&amountEndRange=" + end;
      }
    }
    params += isInflow ? `&voucherType=${VocuherTypes.GST_INVOICE}` : `&voucherType=${VocuherTypes.PURCHASE_INVOICE}`
    if (isInflow) {
      await dispatch(fetchInvoices({ accountId: id, type: 'sales', params: params }));
    } else {
      await dispatch(fetchInvoices({ accountId: id, type: 'purchase', params: params }));
    }

    if (invoices.length > 0) {
      setSelectedInvoice([invoices[0]._id]);
    }
  };
  // Define Users data grid column defs.
  const columns: GridColDef[] = [
    {
      field: "date",
      headerName: 'Date',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <Typography style={{ marginLeft: '-8px' }}>
            { moment(row.date).format("DD MMM YYYY")}
        </Typography>
      )
    },
    {
      field: "payByDate",
      headerName: 'Due Date',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <Typography style={{ marginLeft: '-8px' }}>
            { moment(row.payBydate).format("DD MMM YYYY")}
        </Typography>
      )
    },
    {
      field: "invoiceNumber",
      headerName: 'Invoice #',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <Typography
          sx={{ cursor: 'pointer', fontWeight: 'bold' }}
        >
          {row.invoiceNumber}
        </Typography>
      )
    },
    {
      field: "amount",
      headerName: 'Total Amount',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => {
        // return (<>{Utils.formatNumber(parseFloat(row.amount + additionalChargesSum(row)) || '0', true, true)}
        return (<>{Utils.formatNumber(parseFloat(row.finalAmount || (row.amount + additionalChargesSum(row))) || '0', true, true)}
          {(row.balanceAmount >= 0 || row.balanceAmount <= 0) ?
            <><br />{row.status == 'PAID' ? '' : Utils.formatNumber(parseFloat(row.tempBalanceAmount) || '₹ 0', true, true) + ` (Unpaid)`} </>
            : ''}
        </>);
      }
    },
    
    {
      field: "status",
      headerName: 'status',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <Typography>
            { row.status }
        </Typography>
      )
    },
    {
      field: "paymentAmount",
      headerName: 'Amount Settled',
      type: "int",
      flex: 2,
      renderCell: ({ row, value }: GridValueGetterParams) => {
        const receivedTds = Number(row?.tds?.totalAmount).toFixed(2) || 0;
        const tdsInfo = row?.tdsSelected;
        const paymentAmount = Number(row.paymentAmount || 0);
        const isSelected = selectedRows.includes(row._id);
        
        return (
                      <Box 
                        sx={{ 
                          py: 0.5, 
                          px: 0.5,
                          height: '100%', 
                          width: '100%',
                          display: 'flex', 
                          flexDirection: 'column', 
                          justifyContent: 'center'
                        }}
                      >
                        {/* Payment Amount - Editable when selected */}
                        {isSelected ? (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                            <TextField
                              size="small"
                              type="number"
                              value={paymentAmount}
                              onChange={(e) => handleManualPaymentEdit(e, row)}
                              InputProps={{
                                startAdornment: '₹',
                                inputProps: { 
                                  min: 0,
                                  max: row.balanceAmount,
                                  style: { 
                                    fontSize: '0.875rem',
                                    fontWeight: 600,
                                    padding: '4px 8px'
                                  }
                                }
                              }}
                              sx={{
                                flex: 1,
                                '& .MuiOutlinedInput-root': {
                                  '& fieldset': {
                                    borderColor: row.isManuallyEdited ? '#f59e0b' : '#d1d5db',
                                  },
                                  '&:hover fieldset': {
                                    borderColor: '#059669',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#059669',
                                  },
                                },
                              }}
                            />
                            {row.isManuallyEdited && (
                              <Typography
                                sx={{
                                  fontSize: '0.65rem',
                                  color: '#f59e0b',
                                  fontWeight: 500,
                                  marginLeft: 0.5
                                }}
                              >
                                ✏️
                              </Typography>
                            )}
                          </Box>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                            <Typography 
                              sx={{ 
                                fontWeight: 600, 
                                fontSize: '0.875rem',
                                color: '#374151'
                              }}
                            >
                              {Utils.formatNumber(paymentAmount.toFixed(2))}
                            </Typography>
                            {row.isManuallyEdited && (
                              <Typography
                                sx={{
                                  fontSize: '0.65rem',
                                  color: '#f59e0b',
                                  fontWeight: 500,
                                  marginLeft: 0.5
                                }}
                              >
                                ✏️
                              </Typography>
                            )}
                          </Box>
                        )}
                        
                        {/* Compact TDS Information */}
                        {tdsInfo?.apply && tdsInfo?.tdsSelected && (
                          <Typography 
                            sx={{ 
                              fontSize: '0.7rem',
                              color: '#059669',
                              fontWeight: 500,
                              lineHeight: 1.2
                            }}
                          >
                            TDS {tdsInfo.tdsSelected.rate}%: {Utils.formatNumber(Number(tdsInfo.totalAmount || 0).toFixed(2))}
                          </Typography>
                        )}
                        
                        {/* No TDS Applied */}
                        {(!tdsInfo?.apply || !tdsInfo?.tdsSelected) && (
                          <Typography 
                            sx={{ 
                              fontSize: '0.65rem',
                              color: '#9ca3af',
                              fontStyle: 'italic'
                            }}
                          >
                            {`No TDS Applied. Received Till Now ${receivedTds}` }
                          </Typography>
                        )}
                      </Box>
                    );
      }
    },
    {
      field: "tdsApply",
      headerName: '',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <TdsSelect row={row} />
      )
    }
  ];

  const additionalChargesSum = (invoice: any) => {
    let _additionalCharges;
    let initialSum = 0;
    if (invoice.additionalCharges && invoice.additionalCharges.charges && invoice.additionalCharges.charges.length > 0) {
      _additionalCharges = invoice.additionalCharges.charges.reduce((previousValue: any, currentValue: any) => previousValue + Number(currentValue.value), initialSum);
    } else {
      _additionalCharges = 0;
    }
    return _additionalCharges;
  };

  // Enhanced notification helper functions
  const showSuccess = (message: string) => {
    setSuccessSnackbar({ open: true, message });
    setShowError(false);
  };

  const showWarning = (message: string) => {
    setWarningSnackbar({ open: true, message });
  };

  const showErrorNotification = (message: string) => {
    setErrorSnackbar({ open: true, message });
    setShowError(false);
  };

  const showExcessPaymentDialog = (amount: number, mode: string) => {
    setExcessPaymentDialog({ open: true, amount, mode });
  };

  const handleExcessPaymentChoice = (choice: 'advance' | 'unassigned' | 'cancel') => {
    setExcessPaymentDialog({ open: false, amount: 0, mode: '' });
    
    if (choice === 'advance') {
      showSuccess(`Excess payment of ₹${excessPaymentDialog.amount.toFixed(2)} will be recorded as advance payment.`);
      // The excess amount will be handled in the onSubmit function as advance payment
    } else if (choice === 'unassigned') {
      showSuccess(`Excess payment of ₹${excessPaymentDialog.amount.toFixed(2)} will be recorded as unassigned balance.`);
      // The excess amount will remain as unapplied balance
    }
    // Cancel just closes the dialog
  };

  // OLD SUBMIT FUNCTION - COMMENTED OUT FOR REVERTING
  // Now redirects to PaymentApplication page instead
  
  const onSubmit = async (e: any) => {

    // let total = Number(submitData.base) + Number(submitData.tax) + Number(submitData.tds);
    
    let paymentsArray: PaymentReceipt[] = []

    // Get the latest invoice data from fetchedInvoices for selected rows
    const selectedInvoiceIds = selectedRows;
    const currentSelectedInvoices = fetchedInvoices.filter(inv => 
      selectedInvoiceIds.includes(inv._id) && Number(inv.paymentAmount) > 0
    );

    console.log("Current selected invoices with payment amounts:", currentSelectedInvoices.map(inv => ({
      invoiceNumber: inv.invoiceNumber,
      paymentAmount: inv.paymentAmount,
      isManuallyEdited: inv.isManuallyEdited
    })));

    if (currentSelectedInvoices.length <= 0) {
      toast.error("Please select atleast one invoice to receive the payment");
      return
    }

    currentSelectedInvoices.forEach((invoice:any) => {

      var tdsRate = (invoice?.tdsSelected && invoice?.tdsSelected.tdsSelected) ? invoice?.tdsSelected.tdsSelected.rate : undefined;
      var tdsAmount = tdsRate ? Number((tdsRate * Number(invoice.paymentAmount)) / 100) : 0;

      let attachPaymentToInvoice: PaymentReceipt = {
        invoice: invoice._id,
        invoicePdfTemplateId: invoice.pdfTemplate,
        activityType: 'CHECK',
        appliedAmountBase: Number(invoice.principalAmount),
        appliedAmountTax: invoice.finalTax,
        appliedAmountTDS: tdsAmount,
        tdsSelected: invoice?.tdsSelected || undefined,
        appliedDate: new Date().getTime().toString(),
        appliedAmountTotal: Number(invoice.paymentAmount),
        remarks: "PAID"
      };


      if (isInflow) {
        attachPaymentToInvoice["paymentReceipt"] = data.payment_id;
      } else {
        attachPaymentToInvoice["vpId"] = data.payment_id;
      }
      paymentsArray.push(attachPaymentToInvoice)


    });

    let payLoad: PaymentReceiptApplication = {
      payments: paymentsArray
    };

    console.log("paymentsArray ===  ", payLoad);

    if (isInflow) {
      await dispatch(attachInvoiceToPayment(payLoad));
    } else {
      await dispatch(attachInvoiceToVendorPayment(payLoad));
    }
    onClose(true);
  };
  

  const applyNewPyamentAmount = (amount: any, currentSelectedRows?: any[]) => {
    if(amount.length == 0 ) {
      setAmountRecevied(0);
    } else {
      setAmountRecevied(Number(amount));
    }
    let remainingPayment = Number(amount) || 0;
    console.log(`Total Payment Entered: ${remainingPayment}`);

    // Determine mode: Individual Selection vs Apply to All
    const passedRows = currentSelectedRows !== undefined ? currentSelectedRows : selectedRows;
    const isApplyToAllMode = passedRows.length === 0;
    
    console.log(`Mode: ${isApplyToAllMode ? 'Apply to All Invoices' : 'Individual Selection'}`);
    console.log(`Selected Rows Count: ${passedRows.length}`);

    // 🔹 Reset all invoices before applying new payments, but preserve manually edited values
    let updatedInvoices = fetchedInvoices.map((obj: any) => ({
        ...obj,
        tempBalanceAmount: obj.isManuallyEdited ? obj.tempBalanceAmount : obj.balanceAmount, // Keep manual edits
        paymentAmount: obj.isManuallyEdited ? obj.paymentAmount : 0 // Keep manual payment amounts
    }));

    // 🔹 Determine which invoices to process
    let invoicesToProcess: any[] = [];

    if (isApplyToAllMode) {
      // Apply to ALL invoices - filter out PAID/DRAFT and sort by date (oldest first)
      invoicesToProcess = updatedInvoices
        .filter((invoice: any) => 
          invoice.status !== 'PAID' && 
          invoice.status !== 'DRAFT' && 
          invoice.status !== 'OVER_PAID' &&
          invoice.balanceAmount > 0
        )
        .sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime());
      
      console.log(`Applying payment to ALL ${invoicesToProcess.length} eligible invoices`);
    } else {
      // Apply to SELECTED invoices only
      const selectedInvoiceIds = passedRows.map((row: any) => row._id || row);
      
      invoicesToProcess = updatedInvoices
        .filter((invoice: any) => selectedInvoiceIds.includes(invoice._id))
        .sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime());

      console.log(`Applying payment to ${invoicesToProcess.length} selected invoices`);
    }

    // 🔹 First, subtract manually edited amounts from remaining payment
    let manuallyAllocatedAmount = 0;
    invoicesToProcess.forEach((invoice: any) => {
      if (invoice.isManuallyEdited && invoice.paymentAmount > 0) {
        manuallyAllocatedAmount += Number(invoice.paymentAmount);
      }
    });
    
    remainingPayment = Math.max(0, remainingPayment - manuallyAllocatedAmount);
    console.log(`Manually allocated amount: ${manuallyAllocatedAmount}, Remaining to distribute: ${remainingPayment}`);

    // 🔹 Apply payment to determined invoices (skip manually edited ones)
    invoicesToProcess.forEach((invoice: any) => {
      if (remainingPayment <= 0) return; // Stop if no payment left
      if (invoice.isManuallyEdited) return; // Skip manually edited invoices

      const invoiceFinalAmount = invoice.amount + additionalChargesSum(invoice);
      const balanceAmount = invoice.tempBalanceAmount || invoiceFinalAmount;

      console.log(`Processing Invoice: ${invoice.invoiceNumber}, Balance: ${balanceAmount}, Remaining Payment: ${remainingPayment}`);

      const paymentToApply = Math.min(remainingPayment, balanceAmount);
      console.log("paymentToApply=====  ", paymentToApply);
      remainingPayment -= paymentToApply;
      console.log("remainingPayment=====  ", remainingPayment);

      // Update the invoice in the updatedInvoices array
      const invoiceIndex = updatedInvoices.findIndex((inv: any) => inv._id === invoice._id);
      if (invoiceIndex !== -1) {
        updatedInvoices[invoiceIndex] = {
          ...updatedInvoices[invoiceIndex],
          paymentAmount: Number(paymentToApply).toFixed(2),
          tempBalanceAmount: Number(balanceAmount - paymentToApply).toFixed(2) || 0
        };
      }
    });

    // 🔹 Update selectedRows state if in "Apply to All" mode
    if (isApplyToAllMode) {
      const invoicesWithPayment = updatedInvoices.filter((inv: any) => Number(inv.paymentAmount) > 0);
      setSelectedRows(invoicesWithPayment.map((inv: any) => inv._id));
      setSelectedInvoicesUpdated(invoicesWithPayment);
    }

    console.log("after updated invocies =====  ", remainingPayment);

    // Enhanced Error handling with notifications
    if (invoicesToProcess.length === 0 && !isApplyToAllMode) {
      showErrorNotification("Please select one or more invoices to apply the payment.");
      return; // Exit early to prevent further processing
    } else if (invoicesToProcess.length === 0 && isApplyToAllMode) {
      showErrorNotification("No eligible invoices found. All invoices are either paid, draft, or have zero balance.");
      return; // Exit early to prevent further processing
    } else if (Number(Number(remainingPayment).toFixed(2)) > 0) {
      // Show interactive dialog for excess payment
      const modeText = isApplyToAllMode ? 'eligible' : 'selected';
      showExcessPaymentDialog(Number(remainingPayment), modeText);
    } else if (remainingPayment == 0 && invoicesToProcess.length > 0) {
      // Success case - show success notification
      const modeText = isApplyToAllMode ? 'eligible' : 'selected';
      const settledCount = invoicesToProcess.filter((inv: any) => Number(inv.paymentAmount) > 0).length;
      showSuccess(`Successfully applied payment to ${settledCount} ${modeText} invoice${settledCount > 1 ? 's' : ''}.`);
    } else if (remainingPayment < Number(amount) && invoicesToProcess.length > 0) {
      // Partial settlement case
      const appliedAmount = Number(amount) - remainingPayment;
      const modeText = isApplyToAllMode ? 'eligible' : 'selected';
      showWarning(`Partially applied ₹${appliedAmount.toFixed(2)} to ${modeText} invoices. Some invoices remain unsettled.`);
    } else {
      // Clear any previous errors
      setShowError(false);
      setShowErrorMessage('');
      setShowErrorDesc('');
    }
    setFetchedInvoices(updatedInvoices);

  }

  const handlePaymentAmountChange = (e: any) => {
    console.log( "START ---> On Change event track 11")
    applyNewPyamentAmount(e.target.value)
  };

  const onChange = (e: any, row: any) => {

    // update total amount for invoices, row cell data ( pyament )
    console.log( "START ---> On Change event track 12")

    console.log(e.currentTarget.name);
    console.log(e.currentTarget.value);

    setFetchedInvoices(current =>
      current.map(obj => {
        if (obj._id == row._id) {
          console.log()
          let currentPaymentValue = row.balanceAmount;
          if (e.target.name == 'paymentAmount') {
            console.log("validate target name" + e.target.name);
            currentPaymentValue = e.target.value || 0
          } 
          let returnObj = {
            ...obj, ["paymentAmount"] : Number(currentPaymentValue) || 0
          };
          return returnObj;
        }
        return obj;
      }),
    );

  };

  // const handleCheckboxChange = (event: any, row: any) => {
  //   setFetchedInvoices((prevInvoices) =>
  //     prevInvoices.map((obj) => {
  //       if(obj._id === row._id) {
  //         setAmountRecevied(amountRecevied + )
  //         return {
  //           ...obj,
  //           paymentAmount: event.target.checked ? obj.balanceAmount : 0, // ✅ Set full amount if checked, else reset
  //         }
  //       } else {
  //         return obj
  //       }
  //     })
  //   );
  // };

  const onRowsSelectionHandler = (ids: any) => {

    console.log("onRowsSelectionHandler called === ", ids)
    console.log("onRowsSelectionHandler called  ids.length === ", ids.length)
    setSelectedRows(ids); // Keep selectedRows as array of IDs for selectionModel
    let totalPaymentAmount = Number(0);

    // Clear TDS and manual edits for unchecked rows
    const uncheckedIds = selectedRows.filter((selectedId: any) => !ids.includes(selectedId));
    if (uncheckedIds.length > 0) {
      setFetchedInvoices(current =>
        current.map(obj => {
          if (uncheckedIds.includes(obj._id)) {
            return { 
              ...obj, 
              tdsSelected: undefined, 
              paymentAmount: 0,
              tempBalanceAmount: obj.balanceAmount,
              isManuallyEdited: false 
            };
          }
          return obj;
        })
      );
    }

    if (ids.length > 0) {
      const selectedRowsData = ids.map((id: any) => {
        const row = fetchedInvoices.find((row) => row._id == id);
        const _payment = row?.paymentAmount ? Number(row?.paymentAmount) : Number(row?.balanceAmount)
        totalPaymentAmount += _payment;
        console.log("total Payment Amount after updation .... " + totalPaymentAmount);
  
        return row
      });
      setSelectedInvoicesUpdated(selectedRowsData.filter((row: any) => row !== undefined) as AInvoice[]); // Keep invoice objects separate
      // Remove this line: setSelectedRows(selectedRowsData)
      const newPaymentAmount = (Number(totalPaymentAmount) >= Number(totalPaymentReceiptAmount)) ? totalPaymentReceiptAmount : totalPaymentAmount;
      
      // Pass the current ids directly to avoid async state issues
      applyNewPyamentAmount(newPaymentAmount, ids)
    } else {
      setShowError(false);
      setSelectedInvoicesUpdated([]);
      setSelectedRows([])
      // Pass empty array to indicate no selection
      applyNewPyamentAmount(totalPaymentAmount, [])
    }

  };

  // ✅ Memoize function to prevent unnecessary re-renders
  // const handleStatusChange = useCallback((event, row) => {
  //   const newStatus = event.target.value;

  //   setFetchedInvoices((prevInvoices) =>
  //     prevInvoices.map((obj) =>
  //       obj._id === row._id ? { ...obj, status: newStatus } : obj
  //     )
  //   );
  // }, []);

  // ✅ Memoized Select Component to Avoid Re-Rendering
  const TdsSelect = React.memo((row: any) => {
    const paymentAmount = Number(row.row?.paymentAmount || 0);
    const isDisabled = paymentAmount <= 0;

    return (
      <CustomSelect
        name="tdsSelected"
        id={`tesSelected_${row._id}`}
        label={`Apply Tds`}
        style={{ flex: 1, marginRight: '5px' }}
        variant="outlined"
        size="small"
        options={tdsTaxRateOptions}
        onChange={(event: SelectChangeEvent<any>) => {
          onChangeTdsHandler(event, row);
        }}
        value={row?.tdsSelected?.tdsSelected?._id || ''}
        disabled={isDisabled}
      />
    );
  });

  const handleManualPaymentEdit = (event: any, row: any) => {
    const newPaymentAmount = Number(event.target.value) || 0;
    const maxAmount = row.balanceAmount;
    
    // Validate the amount
    if (newPaymentAmount < 0) return;
    if (newPaymentAmount > maxAmount) return;
    
    // Update the invoice with the new payment amount
    setFetchedInvoices(current =>
      current.map(obj => {
        if (obj._id === row._id) {
          // Clear TDS if payment is zero
          if (newPaymentAmount === 0) {
            return { 
              ...obj, 
              paymentAmount: newPaymentAmount,
              tempBalanceAmount: Number(obj.balanceAmount) - Number(newPaymentAmount),
              tdsSelected: undefined,
              isManuallyEdited: true
            };
          }
          
          // Update TDS amount if TDS is applied
          if (obj.tdsSelected?.apply && obj.tdsSelected?.tdsSelected) {
            const tdsToBeAppliedOnAmount = Number(newPaymentAmount) <= Number(obj.principalAmount) ? newPaymentAmount : obj.principalAmount;
            const tdsAmount = Number((obj.tdsSelected.tdsSelected.rate * Number(tdsToBeAppliedOnAmount)) / 100);
            
            return { 
              ...obj, 
              paymentAmount: newPaymentAmount,
              tempBalanceAmount: Number(obj.balanceAmount) - newPaymentAmount,
              tdsSelected: {
                ...obj.tdsSelected,
                totalAmount: tdsAmount
              },
              isManuallyEdited: true
            };
          }
          
          return { 
            ...obj, 
            paymentAmount: newPaymentAmount,
            tempBalanceAmount: Number(obj.balanceAmount) - newPaymentAmount,
            isManuallyEdited: true
          };
        }
        return obj;
      })
    );
    
    // Recalculate total applied amount
    const totalApplied = fetchedInvoices.reduce((sum, inv) => {
      if (inv._id === row._id) {
        return sum + newPaymentAmount;
      }
      return sum + Number(inv.paymentAmount || 0);
    }, 0);
    
    setTotalAappliedAmount(totalApplied);
  };

  const onChangeTdsHandler = (event: any, row: any) => {
    console.log("======= Called onChangeTdsHandler ====", event.target.value);
    console.log("======= Called onChangeTdsHandler ====", event.target.name);
    console.log("======= Called onChangeTdsHandler ====", event.target.label);

    const selectedRowId = row.row._id;
    console.log("selectedRowId === ", selectedRowId)

    // Find the current row to check paymentAmount
    const currentRow = fetchedInvoices.find(obj => obj._id === selectedRowId);
    const paymentAmount = Number(currentRow?.paymentAmount || 0);

    // Validate paymentAmount > 0 before applying TDS
    if (paymentAmount <= 0) {
      showErrorNotification("TDS can only be applied when payment amount is greater than 0");
      return;
    }

    const d = taxRateOptions.filter(function (item: any) {
      return item._id == event.target.value;
    });

    let updatedInvoices = fetchedInvoices.map((obj: any) => 
      obj._id == selectedRowId ? { ...obj, tdsSelected: {} } : obj
    );
    updatedInvoices = updatedInvoices.map((obj: any) => {
      if(obj._id == selectedRowId ) {

        let tdsToBeAppliedOnAmount = 0;
        console.log("obj.paymentAmount === ", obj.paymentAmount , obj.principalAmount);
        if(Number(obj.paymentAmount) <= Number(obj.principalAmount) ) {
          tdsToBeAppliedOnAmount = obj.paymentAmount
        } else {
          tdsToBeAppliedOnAmount = obj.principalAmount
        }

        console.log("tdsToBeAppliedOnAmount === ", tdsToBeAppliedOnAmount);

        var totalTaxableAmount = Number(Number(obj.principalAmount) + additionalChargesSum(obj));
        var tdsAmount = Number((d[0].taxRate * Number(tdsToBeAppliedOnAmount)) / 100);
        const tdsData = {
          apply: true,
          totalAmount: tdsAmount,
          taxableAmount: obj.principalAmount,
          displayType: 0,
          tdsSelected: {
            _id: event.target.value,
            label: d[0].taxName,
            rate: d[0].taxRate,
            taxSection: d[0].taxSection
          }
        }
        console.log(tdsData);
        return { ...obj, tdsSelected: tdsData };
      }
      return obj;
    });

    console.log(updatedInvoices);

    setFetchedInvoices(updatedInvoices)
  }

  // Function to redirect to PaymentApplication page
  const handleRedirectToPaymentApplication = () => {
    const params = new URLSearchParams({
      paymentId: data.payment_id || '',
      type: isInflow ? 'inflow' : 'outflow',
      buyerId: selectedBuyerOrSupplierId || '',
      buyerName: data.buyer || '',
      amount: data.total_unapplied || '0',
      date: data.payment_date || new Date().toISOString()
    });
    
    // Close the dialog
    onClose(false);
    
    // Navigate to PaymentApplication page
    navigate(`/payments/apply?${params.toString()}`);
  };

  return (
    <div className="" style={{width: "100%", maxWidth: "1200px"}}>
      <FormProvider {...methods}>
        <Box
          sx={{ display: "flex", flexDirection: "column", height: "100vh", padding: "2px 0 2px 2px" }}
          component="form"
          // onSubmit={methods.handleSubmit(onSubmit)}
          noValidate>

            <DialogTitle>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", minHeight: '40px' }}>
                <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.125rem' }}>
                  Apply This Payment to Settle Invoices
                </Typography>
              </Box>
            </DialogTitle>

          <DialogContent>
            <Grid container justifyContent="center" spacing={2} rowSpacing={-2}>
              <Grid item xs={12} md={12} sm={12} lg={12}>
                <div>&nbsp;</div>
              </Grid>
              <Box sx={{ width: '100%', mb: 3 }}>
                <FormProvider {...methods}>
                  <Box sx={{ 
                    width: '100%',
                    display: "flex", 
                    flexDirection: 'row', 
                    justifyContent: 'flex-start', 
                    alignItems: 'end',
                    gap: 2,
                    flexWrap: 'wrap'
                  }}>
                    <Box sx={{ minWidth: 180, flex: 1 }}>
                      <CustomSelect
                        name="statuses"
                        label="Invoice Status"
                        id="statuses"
                        style={{ width: '100%' }}
                        variant="outlined"
                        size="small"
                        options={invoiceStatusOptions}
                        value={selectedInvoiceStatus}
                        onChange={(event: SelectChangeEvent<any>) => {
                          setSelectedInvoiceStatus(event.target.value);
                        }}
                      />
                    </Box>

                    <Box sx={{ minWidth: 180, flex: 1 }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          label="Invoice Start Date"
                          inputFormat="dd/MM/yyyy"
                          value={startDate}
                          onChange={(value) => { handleDateChange(value, 'startDate') }}
                          renderInput={(params) => <TextField {...params} name={'startDate'} variant="outlined" size="small" sx={{ width: '100%' }} />}
                        />
                      </LocalizationProvider>
                    </Box>

                    <Box sx={{ minWidth: 180, flex: 1 }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          label="Invoice End Date"
                          inputFormat="dd/MM/yyyy"
                          value={endDate}
                          onChange={(value) => { handleDateChange(value, 'endDate') }}
                          renderInput={(params) => <TextField {...params} name={'endDate'} variant="outlined" size="small" sx={{ width: '100%' }} />}
                        />
                      </LocalizationProvider>
                    </Box>

                    <Box sx={{ minWidth: 200, flex: 1 }}>
                      <CustomSelect
                        name="amountRange"
                        label="Invoice Amount Range"
                        id="amountRange"
                        style={{ width: '100%' }}
                        variant="outlined" 
                        size="small"
                        options={amountRangeOptions}
                        value={selectedAmountRange}
                        onChange={(event: SelectChangeEvent<any>) => {
                          setSelectedAmountRange(event.target.value);
                        }}
                      />
                    </Box>
                  </Box>
                </FormProvider>
              </Box>

              

              {/* <Divider style={{width: '100%', margin: '20px 5px 15px'}}/> */}
              {/* <Grid item xs={12} md={12} sm={4} lg={12}>
                <div style={{textAlign: 'left'}}>
                  <Typography variant="h5" style={{color: '#647f64'}}> 
                    tdsSelected == {JSON.stringify(fetchedInvoices[0]?.tdsSelected?.tdsSelected?._id || '')}  <br/>
                    _id == {JSON.stringify(fetchedInvoices[0]?._id || '')}  <br/>
                    invoiceNumber == {JSON.stringify(fetchedInvoices[0]?.invoiceNumber || '')}  <br/>
                    balacnceAMount == {JSON.stringify(fetchedInvoices[0]?.balanceAmount || '' )}  <br/>
                    paymentAmount == {JSON.stringify(fetchedInvoices[0]?.paymentAmount || '' )} 

                  </Typography>
                </div>
              </Grid> */}
              <Grid item xs={3} md={3} sm={3} lg={3}>
                <div style={{textAlign: 'left'}}>
                  <Typography variant="h5" style={{color: '#647f64'}}> Total Amount </Typography>
                  <Typography variant="h4" style={{color: 'green'}}>  {Utils.formatNumber(totalPaymentReceiptAmount || 0, true, true)}</Typography>
                </div>
              </Grid>
              <Grid item xs={3} md={3} sm={3} lg={3}>
                <div style={{textAlign: 'left'}}>
                  <Typography variant="h5" style={{color: '#647f64'}}> Total Unapplied  </Typography>
                  <Typography variant="h4" style={{color: 'green'}}>  {Utils.formatNumber((Number(totalUnappliedAmount) - Number(totalAppliedAmount)) || 0, true, true)}</Typography>
                </div>
              </Grid>
              <Grid item xs={3} md={3} sm={3} lg={3}>
                <div style={{textAlign: 'left'}}>
                  <Typography variant="h5" style={{color: '#647f64'}}> Total Applied  </Typography>
                  <Typography variant="h4" style={{color: 'green'}}>  {Utils.formatNumber(totalAppliedAmount || 0, true, true)}</Typography>
                </div>
              </Grid>
              <Grid item xs={3} md={3} sm={3} lg={3}>
                <div style={{textAlign: 'left'}}>
                  <Button
                    sx={{
                      fontSize: '14px',
                      fontWeight: 400,
                      // width: '220px',
                      // marginRight: '-18px',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)'
                      }
                    }}
                    // startIcon={<AddIcon />}
                    variant="contained"
                    color='primary'
                    onClick={() => applyNewPyamentAmount(totalPaymentReceiptAmount, [])}
                    // onClick={handleRedirectToPaymentApplication}
                    >
                    Auto Apply Payment / Distribute Payment
                  </Button>
                  
                {/* <TextField
                  type='number'
                  style={{marginRight: 10, border: '1px Solid #079669', borderRadius: 5}}
                  value={amountRecevied}
                  name="amountRecevied"
                  variant='outlined'
                  size='small'
                  onChange={e => onChange(e, row)}
                /> */}

                  {/* <CustomSelect
                    style={{width:'100%'}}
                    name="tdsSelected"
                    label="Apply TDS"
                    id="applyTds"
                    variant="outlined"
                    // size='small'
                    options={tdsTaxRateOptions}
                    value={tdsSelected._id ?? ""}
                    onChange={onChangeTdsHandler}
                  /> */}
                </div>
              </Grid>
              
              <Divider style={{width: '100%', margin: '20px 5px 15px'}}/>
              <Grid item xs={12} display="flex" justifyContent="flex-end" >
                <Grid container justifyContent="left">
                  <Grid item xs={12}>
                    <Typography style={{fontSize: 16}}> Check the boxes to apply payments for multiple invoices. {showError} </Typography>
                    <Typography style={{fontSize: 14, color: '#6b7280', marginTop: 4}}>
                      💡 Tip: Click on selected invoices to manually edit payment amounts. Manually edited amounts (marked with ✏️) will not be changed by auto-distribution.
                    </Typography>
                    <Typography> {selectedInvoicesUpdated.length > 0 && `Selected Invoices:` } {selectedInvoicesUpdated.map((invoice:any) => `${invoice.invoiceNumber} , `)} </Typography>
                  </Grid>
                </Grid>
              </Grid>
              {showError && showErrorMessage &&
                <Grid item xs={12} md={12} sm={12} lg={12}>
                  <Alert 
                    severity="warning" 
                    sx={{ 
                      mb: 2,
                      '& .MuiAlert-message': { width: '100%' }
                    }}
                  >
                    <Typography variant="body1" sx={{ fontWeight: 500, mb: showErrorDesc ? 0.5 : 0 }}>
                      {showErrorMessage}
                    </Typography>
                    {showErrorDesc && (
                      <Typography variant="body2" sx={{ color: '#6b7280' }}>
                        {showErrorDesc}
                      </Typography>
                    )}
                  </Alert>
                </Grid>
              }
              <div style={{ 
                height: Math.min(Math.max(300, fetchedInvoices.length * 80 + 80), 500), 
                width: '100%', 
                paddingTop: '10px' 
              }}>
                <CustomDataGrid
                  isRowSelectable={(params: any) =>
                      params.row.status != 'DRAFT' && params.row.status != 'PAID' && params.row.status != 'OVER_PAID'}
                  onSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
                  // onSelectionModelChange={onRowsSelectionHandler}
                  selectionModel={memoizedSelectionModel}
                  checkboxSelection={true}
                  disableSelectionOnClick
                  columns={columns}
                  rows={fetchedInvoices}
                  getRowId={(row) => row._id}
                  rowHeight={120}
                  sx={{
                    '& .MuiDataGrid-cell': {
                      whiteSpace: 'normal !important',
                      wordWrap: 'break-word',
                      overflow: 'visible !important',
                      textOverflow: 'unset !important',
                      lineHeight: 'normal',
                      padding: '8px',
                      display: 'flex',
                      alignItems: 'flex-start'
                    },
                    '& .MuiDataGrid-row': {
                      '&:hover': {
                        backgroundColor: 'rgba(5, 150, 105, 0.04)'
                      }
                    },
                    '& .MuiDataGrid-cellContent': {
                      whiteSpace: 'normal',
                      overflow: 'visible',
                      textOverflow: 'unset'
                    }
                  }}
                  loading={status === ApiStatus.LOADING} />
              </div>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Grid container gap='0' sx={{ width: '100%' }}>
              <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1.5}>
                <Button 
                  variant='outlined'
                  onClick={() => {
                    methods.reset();
                    onClose(false);
                  }}
                  sx={{
                    minWidth: '120px',
                    height: '40px',
                    borderRadius: '8px',
                    fontWeight: 500,
                    textTransform: 'none',
                    fontSize: '14px'
                  }}>
                  Cancel
                </Button>
                <LoadingButton
                  type="button"
                  onClick={onSubmit}
                  loading={status === ApiStatus.LOADING}
                  variant="contained"
                  sx={{
                    minWidth: '120px',
                    height: '40px',
                    borderRadius: '8px',
                    fontWeight: 500,
                    textTransform: 'none',
                    fontSize: '14px',
                    backgroundColor: '#059669',
                    '&:hover': {
                      backgroundColor: '#047857'
                    }
                  }}>
                  Record Payment {isInflow ? 'In' : 'Out'}
                </LoadingButton>
              </Grid>
            </Grid>
          </DialogActions>
        </Box>
      </FormProvider>

      {/* Enhanced Error Handling Components */}
      
      {/* Excess Payment Confirmation Dialog */}
      <Dialog 
        open={excessPaymentDialog.open} 
        onClose={() => handleExcessPaymentChoice('cancel')}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                backgroundColor: '#fef3c7',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Typography sx={{ fontSize: '20px' }}>⚠️</Typography>
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, color: '#92400e' }}>
                Excess Payment Detected
              </Typography>
              <Typography variant="body2" sx={{ color: '#6b7280' }}>
                ₹{excessPaymentDialog.amount.toFixed(2)} remains after settling all {excessPaymentDialog.mode} invoices
              </Typography>
            </Box>
          </Box>
        </DialogTitle>
        
        <DialogContent>
          <DialogContentText sx={{ mb: 2, color: '#374151' }}>
            All {excessPaymentDialog.mode} invoices have been fully settled, but there's still an excess amount. 
            How would you like to handle this remaining amount?
          </DialogContentText>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ p: 2, border: '1px solid #e5e7eb', borderRadius: 2, backgroundColor: '#f9fafb' }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#059669', mb: 0.5 }}>
                💰 Record as Advance Payment
              </Typography>
              <Typography variant="body2" sx={{ color: '#6b7280' }}>
                The excess amount will be credited to the customer's account for future invoices
              </Typography>
            </Box>
            
            <Box sx={{ p: 2, border: '1px solid #e5e7eb', borderRadius: 2, backgroundColor: '#f9fafb' }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#7c3aed', mb: 0.5 }}>
                📝 Record as Unassigned Balance
              </Typography>
              <Typography variant="body2" sx={{ color: '#6b7280' }}>
                The excess amount will be kept as unassigned balance for manual allocation
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ p: 3, gap: 1 }}>
          <Button 
            onClick={() => handleExcessPaymentChoice('cancel')}
            variant="outlined"
            sx={{ minWidth: '100px' }}
          >
            Cancel
          </Button>
          <Button 
            onClick={() => handleExcessPaymentChoice('unassigned')}
            variant="outlined"
            sx={{ 
              minWidth: '140px',
              borderColor: '#7c3aed',
              color: '#7c3aed',
              '&:hover': {
                backgroundColor: '#f3f4f6'
              }
            }}
          >
            Unassigned Balance
          </Button>
          <Button 
            onClick={() => handleExcessPaymentChoice('advance')}
            variant="contained"
            sx={{ 
              minWidth: '140px',
              backgroundColor: '#059669',
              '&:hover': {
                backgroundColor: '#047857'
              }
            }}
          >
            Advance Payment
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success Snackbar */}
      <Snackbar
        open={successSnackbar.open}
        autoHideDuration={6000}
        onClose={() => setSuccessSnackbar({ open: false, message: '' })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setSuccessSnackbar({ open: false, message: '' })} 
          severity="success" 
          sx={{ width: '100%' }}
        >
          {successSnackbar.message}
        </Alert>
      </Snackbar>

      {/* Warning Snackbar */}
      <Snackbar
        open={warningSnackbar.open}
        autoHideDuration={8000}
        onClose={() => setWarningSnackbar({ open: false, message: '' })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setWarningSnackbar({ open: false, message: '' })} 
          severity="warning" 
          sx={{ width: '100%' }}
        >
          {warningSnackbar.message}
        </Alert>
      </Snackbar>

      {/* Error Snackbar */}
      <Snackbar
        open={errorSnackbar.open}
        autoHideDuration={6000}
        onClose={() => setErrorSnackbar({ open: false, message: '' })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setErrorSnackbar({ open: false, message: '' })} 
          severity="error" 
          sx={{ width: '100%' }}
        >
          {errorSnackbar.message}
        </Alert>
      </Snackbar>

    </div>
  );
};

export default DialogInvoiceToPaymentForm;